import api from "../services/api";

// FASE4-PASO5 (ronda de seguridad de /public): cuando un chat queda
// abierto mas tiempo que el bloque de expiracion de la firma (6h por
// defecto), la URL de media que el navegador ya tiene cargada deja de
// responder (404). Estas dos funciones piden una URL nueva al backend
// -- que revalida acceso al ticket/chat antes de firmar de nuevo -- y
// devuelven null si el backend la niega (mensaje ajeno, sin acceso,
// etc.), para que el componente que llama decida mostrar su estado de
// error normal en vez de reintentar indefinidamente.
export const resignTicketMessageMedia = async (ticketId, messageId) => {
	if (!ticketId || !messageId) return null;
	try {
		const { data } = await api.get(`/messages/${ticketId}/resign/${messageId}`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};

export const resignChatMessageMedia = async (messageId) => {
	if (!messageId) return null;
	try {
		const { data } = await api.get(`/chats/messages/${messageId}/resign`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};

// FASE4-PASO6a: foto de un contacto -- visible para cualquier usuario de
// la empresa (listas, Kanban, etc.), no ligada a un ticket/chat puntual.
export const resignContactPicture = async (contactId) => {
	if (!contactId) return null;
	try {
		const { data } = await api.get(`/contacts/${contactId}/resign-picture`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};

// FASE4-PASO6b: media de un estado de WhatsApp -- igual que la foto de
// contacto, visible para cualquier usuario de la empresa, no ligada a un
// ticket/chat puntual.
export const resignContactStatusMedia = async (statusId) => {
	if (!statusId) return null;
	try {
		const { data } = await api.get(`/contact-statuses/${statusId}/resign`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};

// FASE4-PASO6c: valor de un campo tipo imagen de un FlowRecord (tablero
// de FlowDatabase) -- visible para cualquier usuario de la empresa, sin
// capa de permisos por tablero (ver ResignFlowRecordImageService.ts).
export const resignFlowRecordImage = async (flowRecordId, fieldDefinitionId) => {
	if (!flowRecordId || !fieldDefinitionId) return null;
	try {
		const { data } = await api.get(`/flow-records/${flowRecordId}/values/${fieldDefinitionId}/resign`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};

// FASE4-PASO6e: adjunto (img/audio/video/document/application) de un
// bloque de contenido del editor de flujos -- igual que la foto de
// contacto, de la empresa directamente, no ligado a ningun ticket/chat.
export const resignFlowMedia = async (fileName) => {
	if (!fileName) return null;
	try {
		const { data } = await api.get(`/flowbuilder/media/${fileName}/resign`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};

// FASE4-PASO6g: adjunto de una respuesta rapida -- el listado "/" de
// un ticket puede quedar abierto mucho mas de 6h, igual que el adjunto
// seleccionado en ScheduleModal.
export const resignQuickMessageMedia = async (quickMessageId) => {
	if (!quickMessageId) return null;
	try {
		const { data } = await api.get(`/quick-messages/${quickMessageId}/resign`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};

// FASE4-PASO6g: foto de un grupo del chat interno -- el chat puede
// quedar abierto toda la jornada.
export const resignChatGroupImage = async (chatId) => {
	if (!chatId) return null;
	try {
		const { data } = await api.get(`/chats/${chatId}/resign-group-image`);
		return data?.url || null;
	} catch (e) {
		return null;
	}
};
